import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TopPicksRow.css';
import { FaCode, FaBriefcase, FaCertificate, FaHandsHelping, FaProjectDiagram, FaEnvelope, FaMountain, FaDumbbell, FaPalette, FaUsers, FaBook, FaChartBar } from 'react-icons/fa';

type ProfileType = 'visionary' | 'collaborator' | 'ai architect' | 'adventurer';

interface CardItem {
  title: string;
  imgSrc: string;
  icon: React.ReactNode;
  route: string;
}

interface TopPicksRowProps {
  profile: ProfileType;
}

export const topPicksConfig: Record<ProfileType, CardItem[]> = {
  visionary: [
    { title: "Experience", imgSrc: "https://picsum.photos/seed/workexperience/250/200", icon: <FaBriefcase />, route: "/work-experience" },
    { title: "Skills", imgSrc: "https://picsum.photos/seed/skills/250/200", icon: <FaCode />, route: "/skills" },
    { title: "Projects", imgSrc: "https://picsum.photos/seed/projects/250/200", icon: <FaProjectDiagram />, route: "/projects" },
    { title: "Certifications", imgSrc: "https://picsum.photos/seed/certifications/250/200", icon: <FaCertificate />, route: "/certifications" },
    { title: "Research & Publications", imgSrc: "https://picsum.photos/seed/research/250/200", icon: <FaBook />, route: "/research-publications" },
    { title: "Recommendations", imgSrc: "https://picsum.photos/seed/recommendations/250/200", icon: <FaHandsHelping />, route: "/recommendations" },
    {
      title: 'Activity Visualization',
      imgSrc: 'https://picsum.photos/seed/activity-data/400/200',
      icon: <FaChartBar />,
      route: '/activity-visualization'
    }
  ],
  collaborator: [
    { title: "Skills", imgSrc: "https://picsum.photos/seed/coding/250/200", route: "/skills", icon: <FaCode /> },
    { title: "Projects", imgSrc: "https://picsum.photos/seed/development/250/200", route: "/projects", icon: <FaProjectDiagram /> },
    { title: "Certifications", imgSrc: "https://picsum.photos/seed/badge/250/200", route: "/certifications", icon: <FaCertificate /> },
    { title: "Experience", imgSrc: "https://picsum.photos/seed/work/250/200", route: "/work-experience", icon: <FaBriefcase /> },
    { title: "Community Impact", imgSrc: "https://picsum.photos/seed/community1/250/140", route: "/community", icon: <FaUsers /> },
    { title: "Personal Growth", imgSrc: "https://picsum.photos/seed/reading2/250/140", route: "/reading", icon: <FaBook /> },
    { title: "Contact Me", imgSrc: "https://picsum.photos/seed/connect/250/200", route: "/contact-me", icon: <FaEnvelope /> },
    {
      title: 'Activity Visualization',
      imgSrc: 'https://picsum.photos/seed/activity-collab/400/200',
      icon: <FaChartBar />,
      route: '/activity-visualization'
    }
  ],
  "ai architect": [
    { title: "Projects", imgSrc: "https://picsum.photos/seed/planning/250/200", route: "/projects", icon: <FaProjectDiagram /> },
    { title: "Experience", imgSrc: "https://picsum.photos/seed/resume/250/200", route: "/work-experience", icon: <FaBriefcase /> },
    { title: "Certifications", imgSrc: "https://picsum.photos/seed/achievements/250/200", route: "/certifications", icon: <FaCertificate /> },
    { title: "Skills", imgSrc: "https://picsum.photos/seed/skills/250/200", route: "/skills", icon: <FaCode /> },
    { title: "Contact Me", imgSrc: "https://picsum.photos/seed/call/250/200", route: "/contact-me", icon: <FaEnvelope /> },
    {
      title: 'Activity Visualization',
      imgSrc: 'https://picsum.photos/seed/activity-ml/400/200',
      icon: <FaChartBar />,
      route: '/activity-visualization'
    }
  ],
  adventurer: [
    { title: "Exploration", imgSrc: "https://picsum.photos/seed/exploration/250/200", route: "/exploration", icon: <FaMountain /> },
    { title: "Fitness Journey", imgSrc: "https://picsum.photos/seed/fitness/250/200", route: "/fitness", icon: <FaDumbbell /> },
    { title: "Creative Projects", imgSrc: "https://picsum.photos/seed/creative/250/200", route: "/projects", icon: <FaPalette /> },
    { title: "Community Impact", imgSrc: "https://picsum.photos/seed/community/250/200", route: "/community", icon: <FaUsers /> },
    {
      title: 'Activity Visualization',
      imgSrc: 'https://picsum.photos/seed/activity-adventure/400/200',
      icon: <FaChartBar />,
      route: '/activity-visualization'
    }
  ]
};

// Helper function to format persona names
const formatPersonaName = (name: string): string => {
  switch (name) {
    case 'ai architect':
      return 'AI Architect';
    default:
      return name.charAt(0).toUpperCase() + name.slice(1);
  }
};

const TopPicksRow: React.FC<TopPicksRowProps> = ({ profile }) => {
  const navigate = useNavigate();
  const topPicks = topPicksConfig[profile];

  return (
    <div className="top-picks-row">
      <h2 className="row-title"><strong>Today's Top Picks for {formatPersonaName(profile)}</strong></h2>
      <div className="card-row">
      {topPicks.map((pick, index) => (
          <div 
            key={index} 
            className="pick-card" 
            onClick={() => navigate(pick.route)}
            style={{ animationDelay: `${index * 0.2}s` }} // Adding delay based on index
          >
            <img src={pick.imgSrc} alt={pick.title} className="pick-image" />
            <div className="overlay">
              <div className="pick-label">{pick.title}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopPicksRow;
